// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MYjp","col":"styles_col__1gNYv"};